import { c as _c } from "react/compiler-runtime";
import NumberFlow from '@number-flow/react';
import { ChevronDownIcon, MessageSquareIcon, ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/toast';
import { useCommentContext } from '@/contexts/comment.context';
import { useCommentsContext } from '@/contexts/comments.context';
import { useCreateVote } from '@/hooks/queries/vote.query';
import { useCommentParams } from '@/hooks/use-comment-params';
import { useSession } from '@/lib/auth-client';
export function CommentActions() {
  const $ = _c(53);
  const {
    slug,
    sort
  } = useCommentsContext();
  const [params] = useCommentParams();
  const {
    comment,
    setIsReplying,
    isOpenReplies,
    setIsOpenReplies
  } = useCommentContext();
  const {
    data: session
  } = useSession();
  const t = useTranslations();
  const t0 = comment.parentId === null ? sort : "oldest";
  const t1 = comment.parentId === null ? "comments" : "replies";
  const t2 = comment.parentId ?? undefined;
  const t3 = params.comment ?? undefined;
  let t4;
  if ($[0] !== slug || $[1] !== t0 || $[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = {
      slug,
      sort: t0,
      type: t1,
      parentId: t2,
      highlightedCommentId: t3
    };
    $[0] = slug;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    mutate: voteComment
  } = useCreateVote(t4);
  const isAuthenticated = session !== null;
  let t5;
  if ($[6] !== comment.id || $[7] !== comment.liked || $[8] !== isAuthenticated || $[9] !== t || $[10] !== voteComment) {
    t5 = function handleVoteComment(like) {
      if (!isAuthenticated) {
        toast.add({
          type: "error",
          title: t("error.need-logged-in-to-vote")
        });
        return;
      }
      voteComment({
        id: comment.id,
        isLike: like === comment.liked ? null : like
      });
    };
    $[6] = comment.id;
    $[7] = comment.liked;
    $[8] = isAuthenticated;
    $[9] = t;
    $[10] = voteComment;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleVoteComment = t5;
  const hasReplies = !comment.parentId && comment.replyCount > 0;
  let t6;
  if ($[12] !== handleVoteComment) {
    t6 = () => {
      handleVoteComment(true);
    };
    $[12] = handleVoteComment;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = comment.liked === true;
  let t8;
  if ($[14] !== t) {
    t8 = t("common.like");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ThumbsUpIcon />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== comment.likeCount) {
    t10 = <NumberFlow value={comment.likeCount} />;
    $[17] = comment.likeCount;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t11 = <Button variant="secondary" onClick={t6} data-active={t7} size="sm" className="font-mono text-xs text-muted-foreground data-active:bg-accent data-active:text-accent-foreground" aria-label={t8}>{t9}{t10}</Button>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== handleVoteComment) {
    t12 = () => {
      handleVoteComment(false);
    };
    $[24] = handleVoteComment;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = comment.liked === false;
  let t14;
  if ($[26] !== t) {
    t14 = t("blog.comments.dislike");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ThumbsDownIcon />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== comment.dislikeCount) {
    t16 = <NumberFlow value={comment.dislikeCount} />;
    $[29] = comment.dislikeCount;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t16) {
    t17 = <Button variant="secondary" onClick={t12} data-active={t13} size="sm" className="font-mono text-xs text-muted-foreground data-active:bg-accent data-active:text-accent-foreground" aria-label={t14}>{t15}{t16}</Button>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== comment.parentId || $[37] !== setIsReplying || $[38] !== t) {
    t18 = comment.parentId ? null : <Button variant="secondary" size="sm" className="text-xs text-muted-foreground" onClick={() => {
      setIsReplying(true);
    }} data-testid="comment-reply-button"><MessageSquareIcon />{t("blog.comments.reply")}</Button>;
    $[36] = comment.parentId;
    $[37] = setIsReplying;
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t11 || $[41] !== t17 || $[42] !== t18) {
    t19 = <div className="flex gap-1">{t11}{t17}{t18}</div>;
    $[40] = t11;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== comment.replyCount || $[45] !== hasReplies || $[46] !== isOpenReplies || $[47] !== setIsOpenReplies || $[48] !== t) {
    t20 = hasReplies && <Button variant="ghost" size="sm" className="mt-4 text-xs data-open:[&>svg]:rotate-180" onClick={() => {
      setIsOpenReplies(!isOpenReplies);
    }} data-state={isOpenReplies ? "open" : "closed"} data-testid="comment-replies-expand-button"><ChevronDownIcon data-icon="inline-start" className="size-4 transition-transform duration-200" /><NumberFlow value={comment.replyCount} data-testid="comment-reply-count" />{t("blog.comments.replies", {
        count: comment.replyCount
      })}</Button>;
    $[44] = comment.replyCount;
    $[45] = hasReplies;
    $[46] = isOpenReplies;
    $[47] = setIsOpenReplies;
    $[48] = t;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t19 || $[51] !== t20) {
    t21 = <>{t19}{t20}</>;
    $[50] = t19;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  return t21;
}